var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOixioLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 797 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.821 87.0824C141.271 87.0824 156.233 101.895 156.233 120.162C156.233 138.429 141.271 153.241 122.821 153.241C104.37 153.241 89.4085 138.429 89.4085 120.162C89.4085 101.895 104.37 87.0824 122.821 87.0824ZM61.3125 120.162C61.3125 153.79 88.854 181.057 122.821 181.057C156.787 181.057 184.329 153.79 184.329 120.162C184.329 86.5338 156.787 59.2666 122.821 59.2666C88.854 59.2666 61.3125 86.5338 61.3125 120.162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.558 63.0039H245.223V177.336H273.558V63.0039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M707.823 120.162C707.823 138.429 692.86 153.241 674.41 153.256C655.954 153.256 640.995 138.429 640.995 120.162C640.995 101.895 655.954 87.0824 674.41 87.0824C692.86 87.0824 707.823 101.895 707.823 120.162ZM674.41 59.2666C640.44 59.2666 612.898 86.5338 612.898 120.162C612.898 153.79 640.44 181.072 674.41 181.072C708.371 181.072 735.912 153.805 735.912 120.162C735.912 86.5188 708.371 59.2666 674.41 59.2666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M552.004 63.0039H523.668V177.336H552.004V63.0039Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M398.627 101.91L375.413 120.192V120.148L345.266 96.3798V59.8604L398.627 101.91Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M398.627 101.911V138.431L345.266 180.48V143.961L398.627 101.911Z",
    fill: "#AFB0B1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M451.974 143.961V180.48L398.613 138.431V101.911L451.974 143.961Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M398.629 101.911L421.738 120.133L451.975 96.3795V59.8457L398.629 101.911Z",
    fill: "#AFB0B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOixioLogo);
export default __webpack_public_path__ + "static/media/oixio_logo.e6a83fe8fa46573ad696b8c5883d0723.svg";
export { ForwardRef as ReactComponent };